import {getCurrentIdToken} from "./firebase/firebaseClient";
import {
    resolveTypesenseSearchCredentials,
    type TypesenseAuthResponse,
    type TypesenseSearchCredentials,
} from "./typesenseCredentials";
import {getAccountsApiBase} from "./utils/apiBase";
import {fetchWithRetry} from "./utils/fetchWithRetry";

export type TypesenseIdTokenGetter = () => Promise<string | null>;

export async function fetchTypesenseSearchCredentials(
    getIdToken: TypesenseIdTokenGetter = getCurrentIdToken,
    fetchResponse: typeof fetch = fetch,
    accountsApiBase = getAccountsApiBase(),
): Promise<TypesenseSearchCredentials> {
    const token = await getIdToken();
    const res = await fetchWithRetry(() =>
        fetchResponse(`${accountsApiBase}/accounts/auth/typesense`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? {Authorization: `Bearer ${token}`} : {}),
            },
            body: JSON.stringify({}),
        }),
    );
    if (!res.ok) {
        throw new Error(`Typesense auth failed: ${res.status}`);
    }
    const data = (await res.json()) as TypesenseAuthResponse;
    return resolveTypesenseSearchCredentials(data);
}
